<lgb-header-gradient [height]="((remote()?.logo)? 180 : 100)" [background]="remote()?.logo==null"></lgb-header-gradient>
<div class="screen-container" [loading]="loading()">
	@if(remote()?.logo){
		<div class="logo">
			<img hSkeleton="150px" src="{{remote()?.logo}}"/>
		</div>
	}
	<lgb-back name="scrap-home"></lgb-back>
	<h1 class="my-4">{{remote()?.name}}</h1>
	<div class="set-items">
		@if(remote()?.symbol){
			<div>
				<img class="symbol" hSkeleton="30px" wSkeleton="30px" src={{remote()?.symbol}}/>
			</div>
		}
		<div>
			<i class="badge-icon badge badge-soft badge-primary fa-regular fa-cards-blank"></i>
			{{remote()?.nbCards}}
		</div>
		<div>
			@if(remote()?.lastUpdate){
				{{remote().lastUpdate | date:'dd/MM/yyyy HH:mm'}}
			}
			@else{
				Non importé
			}
		</div>
		<div class="importing">
			@if(!importing()){
				<a (click)="importSet()">
				    <i class="icon-import fa-regular fa-download text-primary"></i>
				</a>
			}
			@else{
				<a (click)="stopImport()">
					<i class="text-error fa-solid fa-circle-stop"></i>
				</a>
				<div class="wait-loading" [loading]="importing()"></div> 
			}
		</div>
	</div>
	<div class="tabs tabs-box mb-4">
		  <a (click)="tabActive.set('logs')" [ngClass]="{'tab-active': tabActive()=='logs'}" class="tab">Logs</a>
		  <a (click)="tabActive.set('error')" [ngClass]="{'tab-active': tabActive()=='error'}" class="tab">
		  	<span [ngClass]="{'text-error': errors.logs.length-1}">Errors </span>
		  	<div [ngClass]="{'badge-error': errors.logs.length-1}" class="badge badge-sm ml-1">{{errors.logs.length-1}}</div>
		  </a>
		  <a (click)="tabActive.set('cards')" [ngClass]="{'tab-active': tabActive()=='cards'}" class="tab">Cards</a>
	</div>
	<div [ngStyle]="{display: ((tabActive()=='logs')? 'block': 'none')}">
		<lgb-console [logs]="logs" [valLoad]="valLoad()" [maxLoad]="maxLoad()"></lgb-console>
	</div>
	<div [ngStyle]="{display: ((tabActive()=='error')? 'block': 'none')}">
		<lgb-console [logs]="errors"></lgb-console>
	</div>
	<div [ngStyle]="{display: ((tabActive()=='cards')? 'block' : 'none')}">
		@if(cards().length){
			<p class="element-info mb-2">
				<i class="text-primary fa-light fa-arrow-rotate-right"></i> Relancer l'étape selectionnée<br/>
				<i class="text-primary fa-light fa-arrows-retweet"></i> Relancer l'étape seléctionné et les suivantes
			</p>
			<ul class="list bg-base-100 rounded-box shadow-md">
			  <li class="header-cards p-4 pb-2 text-xs opacity-60 tracking-wide">
			  	<div>
			  		Remotes cards
			  	</div>
			  	<div class="view-switch">
					Erreur
					<input type="checkbox" [(ngModel)]="isError" class="ml-2 toggle border-white-600 bg-white-500 checked:border-indigo-500 checked:bg-indigo-400 checked:text-indigo-800" />
				</div>
			  </li>
				@for(card of cardList(); track card.id; let i=$index){
				  <li class="list-row">
			  	    <div class="text-4xl font-thin opacity-30 tabular-nums">
			  	    	{{card.id}}
			  	    </div>
				    <div class="card-name">
	  	    		  <img class="size-10 rounded-box mr-4" [altImg]="getRemoteImg(card.image)"/>
	  	    		  <div>
					      <div>{{card.name}}</div>
					      <span class="badge badge badge-soft badge-sm text-xs font-semibold opacity-60" [ngClass]="getClassState(card.stateImport)">{{card.stateImport ?? 'En attente'}}</span>
					  </div>
				    </div>
				    <button (click)="replay(card)" class="btn btn-square btn-ghost" [disabled]="importing()">
				      <i class="fa-regular fa-arrow-rotate-right"></i>
				    </button>
				    <button (click)="replayLoop(card)" class="btn btn-square btn-ghost" [disabled]="importing()">
				      <i class="fa-regular fa-arrows-retweet"></i>
				    </button>
				  </li>
				}
			</ul>
		}
		@else{
			<div class="text-center">
				Aucune carte à importer pour l'instant.
			</div>
		}
	</div>
</div>